module.exports = __webpack_public_path__ + "ef08403314d7b9760578ebc34c90b872.png";